import { AppHeader } from '../utils/interfaces/app-header';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MdsIcon, MdsIconsModule } from '@mds/icons';
import { AppItem } from '@mds/common';
import { HeaderContainerComponent } from '../header-container/header-container.component';
import { LoaderModule } from '@mds/ui';
import { FormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-common-apps',
  standalone: true,
  templateUrl: './common-apps.component.html',
  styleUrls: ['./common-apps.component.scss'],
  imports: [
    CommonModule,
    MdsIconsModule,
    HeaderContainerComponent,
    LoaderModule,
    FormsModule,

  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonAppsComponent {
  isNeedToProcessItems = false;
  protected readonly icons = MdsIcon;
  @Input() hasDashBorder = false;
  @Input() appDetails: AppHeader;
  @Input() loading: boolean;
  @Input() extraData: { list: AppItem[]; selectedList: AppItem[] };

  private _appsData: any;
  @Input()
  set appsData(value: any) {
    this._appsData = value;
  }
  get appsData(): any {
    return this._appsData;
  }
  private _appItems: AppItem[];
  @Input() set appItems(values: AppItem[]) {
    if (values) {
      this._appItems = values;
      this.isNeedToProcessItems = true;
      this.processAppItems(values);
    }
  }
  get appItems(): AppItem[] {
    return this._appItems;
  }
  @Input() isShowSeeMore: boolean;
  @Output() onAppDataClick = new EventEmitter<any | string>();
  @Output() headerEvent = new EventEmitter<any>();

  processAppItems(values: AppItem[]) {
    this.appsData = values.map((appItem) => ({
      name: appItem.app_name,
      description: appItem.description_short,
      icon: this.getAppIcon(appItem),
    }));
  }
  clickApp(name: string, index: number) {
    if (this.isNeedToProcessItems) {
      this.onAppDataClick.emit(this.appItems[index]);
    } else {
      this.onAppDataClick.emit(name);
    }
  }

  handleButtonClick(data: any) {
    this.headerEvent.emit(data);
  }
  private getAppIcon(appItem: AppItem) {
    let appIcon = null;
    Object.entries(MdsIcon)
      .filter((key) => key[0].toLowerCase().startsWith('app'))
      .forEach((value) => {
        const fileName = appItem?.icon_app
          ?.split('/')
          ?.pop()
          ?.split('.')[0]
          .replace(/[-_]/g, ''); // 'bom-explorer'
        const transformedStr1 = value[0]
          .replace('APP_', '')
          .toLowerCase()
          .replace(/[-_]/g, '');
        if (fileName === transformedStr1) {
          appIcon = MdsIcon[value[0]];
        }
      });
    if (!appIcon && appItem?.data?.default_icon) {
      appIcon = MdsIcon.APP_IMPORTER_DEFAULT;
    }
    return appIcon;
  }
}
